import { Field, useFormikContext } from 'formik'

import RadioButton from 'components/RadioButton'

const AccountType = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext()

  return (
    <section className="item-settings__section">
      <h3 className="header-title">Account Type</h3>
      <div className="content-wrapper -flags-wrapper -block">
        <span className="content-value">
          <Field
            component={RadioButton}
            name="role"
            placeholder="Cashier"
            type="radio"
            checked={values.role === 'cart_attendant'}
            onClick={() => {
              setFieldValue('role', 'cart_attendant')
            }}
            disabled={disabled}
          />
        </span>
        <p className="description margin-top-xxs margin-bottom-none color-disabled">
          Unable to void/refund.
        </p>
      </div>
      <div className="content-wrapper -flags-wrapper -block">
        <span className="content-value">
          <Field
            component={RadioButton}
            name="role"
            placeholder="Manager"
            type="radio"
            checked={values.role === 'manager'}
            onClick={() => {
              setFieldValue('role', 'manager')
            }}
            disabled={disabled}
          />
        </span>
        <p className="description margin-top-xxs margin-bottom-none color-disabled">
          Voiding and Refund capabilities. This user is able to
          approve any POS changes that require a Manager PIN.
        </p>
      </div>
    </section>
  )
}

export default AccountType
